
// Site Wide Funcitons

document.addEventListener("DOMContentLoaded", function(event) {
	siteWideFunctions();	
});

window.addEventListener('resize', browserHeight);

var lazyLoadInstance;

function siteWideFunctions() {

	lazyLoadInstance = new LazyLoad({
		elements_selector: ".lazy"
	});

	eventListeners();
	initialiseCarousels();
	newsletterSignup();
	pageScrolling();
	browserHeight();

	if(document.querySelector('.enquiry--form')) {
		enquiryFormFunctions();
	}
	
	if(document.querySelector('.detailed-product--single')) {
		productFunctions();
	}

	if(document.querySelector('.product--sidebar')) {
		productFiltering();
	}
	if(document.querySelector('.open-side--panel')) {
		openSidePanel();
	}
	if(document.querySelector('.featured-products--collection')) {
		featuredCollections();
	}
	if(document.querySelector('.contact-form--navigation')) {
		contactPageFunctions();
	}
	if(document.querySelector('.archive-ring--card')) {
		archiveRingFunction();
	}
	if(document.querySelector('.mobile-dropdown')) {
		mobileDropdowns();
	}

	if (window.location.href.indexOf("?contact_posted=true") > -1) {
		formSuccess();
	}
}

function formSuccess() {
	var panel = document.querySelector('.product-enquiry--panel');
	var background = document.querySelector('.product-enquiry--background');
	panel.querySelector('.form--success').style.display = 'block';
	panel.querySelector('.form--fields').style.display = 'none';
	panel.querySelector('.product--button').innerHTML = '<div class="p20 text-center bt1 bg-white pos-rel z-2">Success</div>';
	panel.classList.add('is-active');
	background.classList.add('is-active');
}

// Browser Height Function 

window.addEventListener('resize', browserHeight);

function browserHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
}

function mobileDropdowns() {
	var dropdowns = document.querySelectorAll('.mobile-dropdown');
	for (i = 0; i < dropdowns.length; i++) {
  		dropdowns[i].addEventListener("click", function(e) { 
  			e.target.closest('.mobile-dropdown').classList.toggle('active');
  		});
  	}
}


function pageScrolling() {
	var cart = document.querySelector('.fixed--cart');
	if(!cart) return;
	cart.classList.add('load-in');
	cart.classList.add('fade-in');
	let scrolling = false;
	window.addEventListener('scroll',(event) => {
	    scrolling = true;
	});

	setInterval(() => {
	  if(scrolling) {
	    scrolling = false;
	    scrollingFunction();
	  }
	},300);
}

function scrollingFunction() {
	var pageTitle = document.querySelector('.page-title--text');
	 
	if(document.documentElement.scrollTop > 150) {
		pageTitle.classList.add('fade-in');
	} else {
		pageTitle.classList.remove('fade-in');
	}
}

function newsletterSignup() {
	$('form.subscribe-form').submit(function(e) {
	  var $this = $(this);
	  $.ajax({
	      type: "GET",  
	      url: "https://agdesignerjeweller.us3.list-manage.com/subscribe/post-json?u=58a4431d2675e52f6e2f4c59b&amp;id=aefb3c07ae&c=?",
	      data: $this.serialize(),
	      dataType    : 'json',
	      contentType: "application/json; charset=utf-8",
	      error       : function(err) {$('.subscribe-form .signup-message').html('<p class="message small failed">Please enter a valid email address & ensure you are not already signed up.</p>'); },
	      success     : function(data) {
	          if (data.result != "success") {
	          	$('.subscribe-form .signup-message').html('<p class="message small failed">Please enter a valid email address & ensure you are not already signed up.</p>');
	          } else {
	            $('.subscribe-form').html('<p class="message small">Thank You for signing up.</p>'); 
	          }
	      }
	  });
	  return false;
	});
}

// Form Functionality

function enquiryFormFunctions() {
	var success = document.querySelector('.contact-form--success');
	var errors = document.querySelector('.contact-form--errors');
	var enquiryPanel = document.querySelector('.product-enquiry--panel');
	var enquiryBackground = document.querySelector('.product-enquiry--background');
	var closePopup = document.querySelector('.close--popup');
	var popup = document.querySelector('.success--popup');

	if(success.innerHTML != '') {
		popup.classList.add('is-active');
		setTimeout(function(){ 
			popup.classList.add('fade-in');
		}, 100);
	}

	closePopup.addEventListener("click", function(e) { 
		popup.classList.remove('fade-in');
		setTimeout(function(){ 
			popup.classList.add('is-active');
		}, 500);
	});

	if(errors.innerHTML != '') {
		enquiryPanel.classList.add('is-active');
		enquiryBackground.classList.add('is-active');
	}
}

// Archive Page Functionality

function archiveRingFunction() {
	openSidePanel();  	
}

// Contact form navigation

function contactPageFunctions() {
	var map = document.querySelector('.show-map--panel');
	var dropdown = document.querySelector('.ring-type--dropdown');

	dropdown.addEventListener("change", function(e) { 
		if(e.target.value == 'Engagement ring') {
			var fields = document.querySelector('.engagement-ring--fields');
			var height = fields.querySelector('.inner').offsetHeight;
			fields.style.height=height+'px';
		}
	});

	map.addEventListener("click", function(e) { 
		document.querySelector('.map--container').classList.add('is-active');
		if(window.innerWidth < 768) {
			window.scrollTo(0,document.querySelector('#showroom').offsetTop); 
		} 
	});
	map.addEventListener("mouseover", function(e) { 
		document.querySelector('.map--container').classList.add('is-hover');
	});
	map.addEventListener("mouseout", function(e) { 
		document.querySelector('.map--container').classList.remove('is-hover');
	});
}

// Featured Collection Functionality 

function featuredCollections() {
	var links = document.querySelectorAll('.collection-navigation--links .link');
	for (i = 0; i < links.length; i++) {
  		links[i].addEventListener("click", function(e) { 
  			var currentLink = document.querySelector('.collection-navigation--links .link.active');
  			if(currentLink) {
  				currentLink.classList.remove('active');
  			}
			e.target.classList.add('active');
			var collection = e.target.getAttribute('data-title');
			var current = document.querySelector('.featured-products--collection.is-active');
			if(current) {
				current.classList.remove('is-active');
			}
			document.querySelector('.featured-products--collection[data-collection="'+collection+'"]').classList.add('is-active');
		});
	}
	var dropdown = document.querySelector('.collection-navigation--select');
	dropdown.addEventListener("change", function(e) { 
		var collection = dropdown.value;
		var current = document.querySelector('.featured-products--collection.is-active');
		if(current) {
			current.classList.remove('is-active');
		}
		if(collection == 'Shop All') {
			window.location.href = '/collections/all';
		} else {
			document.querySelector('.featured-products--collection[data-collection="'+collection+'"]').classList.add('is-active');
		}
	});	
}

// Open Panel Functionality

function openSidePanel() {
	var panel = document.querySelector('.product-enquiry--panel');
	var background = document.querySelector('.product-enquiry--background');
	var close = document.querySelector('.close-enquiry--form');
	var panelLinks = document.querySelectorAll('.open-side--panel');
	
	for (i = 0; i < panelLinks.length; i++) {
  		panelLinks[i].addEventListener("click", function(e) { 
  			if(e.target.getAttribute('data-title')) {
  				document.querySelector('.contact-panel--title').innerHTML = e.target.getAttribute('data-title');
  			}
			openPanel();
		});
	}
	
	background.addEventListener("click", function(e) { 
		closePanel();
	});

	close.addEventListener("click", function(e) { 
		closePanel();
	});

	function openPanel() {
		panel.classList.add('is-active');
		background.classList.add('is-active');
	}

	function closePanel() {
		panel.classList.remove('is-active');
		background.classList.remove('is-active');
	}

}

// Product Filtering Functions

function productFiltering() {
	var button = document.querySelector('.show-filters--button');
	var filterSidebar = document.querySelector('.product--sidebar');
	var filterContainer = document.querySelector('.product--container.container-with--sidebar')
	button.addEventListener("click", function(e) { 
		if(filterSidebar.classList.contains('is-active')) {
			filterSidebar.classList.remove('is-active');
			filterContainer.classList.remove('is-active');
			button.classList.remove('is-active');
		} else {
			filterSidebar.classList.add('is-active');
			filterContainer.classList.add('is-active');
			button.classList.add('is-active');
		}
	});

	var dropdowns =  document.querySelectorAll('.filtering--dropdown .header');

	for (i = 0; i < dropdowns.length; i++) {
  		dropdowns[i].addEventListener("click", function(e) { 
  			var parent = e.target.closest('.filtering--dropdown'); 
  			var options = parent.querySelector('.options'); 
  			var optionsInner = parent.querySelector('.options--inner'); 
  			var height = optionsInner.offsetHeight;
  			if(parent.classList.contains('is-active')) {
  				parent.classList.remove('is-active');
  				options.style.height =null; 
  			} else {
  				parent.classList.add('is-active');
  				options.style.height = height+'px';
  			}
  		}); 
  	}

  	var priceRange = document.querySelectorAll('.price-range--filter .selection');

  	var first;
  	var second;
	
	for (i = 0; i < priceRange.length; i++) {
		if(priceRange[i].innerHTML.indexOf("$0") !== -1) {
			first = priceRange[i];
		}
		if(priceRange[i].innerHTML.indexOf("$5000") !== -1) {
			second = priceRange[i];
		}
	}

	first.parentNode.removeChild(first);
	second.parentNode.removeChild(second);

	document.querySelector('.price-range--filter .options--inner').prepend(second);
	document.querySelector('.price-range--filter .options--inner').prepend(first);
}

// Product Functions

function productFunctions() {
	var consultLink = document.querySelector('.how-it-works .ul-link');
	var enquire = document.querySelector('.product--enquiry');
	var enquiryPanel = document.querySelector('.product-enquiry--panel');
	var enquiryBackground = document.querySelector('.product-enquiry--background');
	var enquiryClose = document.querySelector('.close-enquiry--form'); 
	var variants =  document.querySelector('.select-variants--button'); 

	enquire.addEventListener("click", function(e) { 
		openEnquiry();
	});  

	consultLink.addEventListener("click", function(e) { 
		e.preventDefault();
		document.querySelector('.contact-panel--title').innerHTML = 'Make an Appointment'
		var subject = document.querySelector('#ContactFormName');
		var message = subject.getAttribute('value').split('Ring Enquiry')[1];
		message = 'Book an Appointment'+message;
		subject.setAttribute('value',message);
		console.log(subject)
		openEnquiry();
	});  

	var dropdowns = document.querySelector('.product-selection--dropdowns');
	
	if(dropdowns) {
		var label = dropdowns.getAttribute('data-label');
		if(label) {
			var lbl = document.createElement('label');
			lbl.innerHTML = label;
			dropdowns.querySelector('.selector-wrapper').prepend(lbl); 
		}             
	}

	if(variants) {
		var button = document.querySelector('button.product--button');
		if(button) {
			button.setAttribute('disabled', true);
		}

		if(document.querySelector('.size-dropdown')) {
			document.querySelector('.size-dropdown').addEventListener("change", function(e) { 
				var selection = e.target.value;
				console.log(selection)
				if(selection=='Other') {
					document.querySelector('.custom-wrapper').classList.add('active');
					document.querySelector('.product--variants').style.height='unset';
				}
			}); 
		}
	 	 
	 	variants.addEventListener("click", function(e) { 
			showVariants();
		}); 
	}
	enquiryBackground.addEventListener("click", function(e) { 
		closeEnquiry();
	});

	enquiryClose.addEventListener("click", function(e) { 
		closeEnquiry();
	});  

	function openEnquiry() {
		enquiryPanel.classList.add('is-active');
		enquiryBackground.classList.add('is-active');
	}

	function closeEnquiry() {
		enquiryPanel.classList.remove('is-active');
		enquiryBackground.classList.remove('is-active');
	}

	function closePopup() {
		var popup = document.querySelector('.cart--popup');
	}

	if(document.querySelector('.product--price-guide')) {
		priceRangeSelection();
	}
}

function showVariants() {
	var button = document.querySelector('button.product--button');
	if(button) {
		button.removeAttribute('disabled');
	}
	document.querySelector('.select-variants--button').classList.add('is-hidden');
	document.querySelector('.product-pricing--variants').classList.add('is-active');
	var variants = document.querySelector('.product--variants');
	var height = variants.querySelector('.inner').offsetHeight;
	variants.style.height = height+'px'; 
}

function priceRangeSelection() {
	var priceSelection = document.querySelector('.budget--selection');
	var priceRange = document.querySelector('.budget-range');
	var priceOptions = document.querySelectorAll('.budget-range .selection');
	
	priceSelection.addEventListener("click", function(e) { 
		priceRange.classList.toggle('is-active');
		if(priceRange.classList.contains('is-active')) {
			priceSelection.classList.add('active');
		} else {
			priceSelection.classList.remove('active'); 
		} 
	});  

	for (i = 0; i < priceOptions.length; i++) {
		priceOptions[i].addEventListener("click", function(e) { 
			var selection = document.querySelector('.budget-range .selection.active');
			if(selection) {
				selection.classList.remove('active');
			}
			e.target.classList.add('active');
			priceSelection.querySelector('.inner').innerHTML = e.target.innerHTML;
			setPriceRange(e.target.getAttribute('data-low'), e.target.getAttribute('data-high'));
			setTimeout(function(){ 
				priceRange.classList.remove('is-active');  
			}, 500);
		}); 
	}

	function setPriceRange(low,high) {

		document.querySelector('.product-price--range').classList.add('is-active');
		document.querySelector('.product-price--range').classList.add('is-changing');
		setTimeout(function(){ 
			if(!low) {
				document.querySelector('.product-price--range').classList.add('high-value');
			} else {
				document.querySelector('.product-price--range').classList.remove('high-value');
			}
			document.querySelector('.product-price--range .minimum .carot').innerHTML = low;
			document.querySelector('.product-price--range .maximum .carot').innerHTML = high;
			document.querySelector('.product-price--range').classList.remove('is-changing');
		}, 750);
	}
}

// Menu Functions

function menuFunctions() {
	var menu = document.querySelector('.menu-toggle--button');
	var masthead = document.querySelector('.masthead--container');
	var sidebar = document.querySelector('.side-menu--container');
	var background = document.querySelector('.menu--background');
	var mobile = document.querySelector('.mobile-menu-icon');
	var mobileOverlay = document.querySelector('.mobile--overlay');

	// Mobile menu 

	mobile.addEventListener("click", function(e) { 
		if(mobileOverlay.classList.contains('is-active')) {
			mobileOverlay.classList.remove('is-active');
			mobile.classList.remove('active');
		} else {
			mobileOverlay.classList.add('is-active');
			mobile.classList.add('active');
		}
	}); 

	// Mobile return menu

	var mobileReturn = document.querySelector('.return-to--menu');
	mobileReturn.addEventListener("click", function(e) { 
		document.querySelector('.mobile--submenu.active').classList.remove('active');
		document.querySelector('.mobile--submenu.primary-submenu').classList.add('active');
		mobileReturn.classList.remove('active');
	}); 

	// Mobile menu sublinks

	var mobileLinks = document.querySelectorAll('.primary-submenu.mobile--submenu .menu-item a');
	var mSubLinks = ['Shop', 'Engagement', 'Wedding', 'Bespoke'];
	for (i = 0; i < mobileLinks.length; i++) {
		mobileLinks[i].addEventListener("click", function(e) { 
			if(mSubLinks.includes(e.target.innerHTML)) {
				console.log('internal link clicked')
				e.preventDefault();
				var title = e.target.innerHTML;

				var current = document.querySelector('.mobile--submenu.active');
				if(current) {
					current.classList.remove('active');
				}
				var next = document.querySelector('.mobile--submenu[data-menu="'+title+'"]');
				if(next) {
					next.classList.add('active');
					mobileReturn.querySelector('.title').innerHTML=title;
					mobileReturn.classList.add('active');
				}
			}
		}); 
	}

	// Menu Open & Close

	menu.addEventListener("click", function(e) { 
		if(masthead.classList.contains('is-active')) {
			closeMenu();
		} else {
			openMenu();
		}
	});  

	background.addEventListener("click", function(e) { 
		closeMenu();
	});  

	function openMenu() {
		masthead.classList.add('is-active');
		sidebar.classList.add('is-active');
		background.classList.add('is-active');
	}

	function closeMenu() {
		masthead.classList.remove('is-active');
		sidebar.classList.remove('is-active');
		background.classList.remove('is-active');
		masthead.classList.remove('with-submenu');
		sidebar.classList.remove('with-submenu');
		if(document.querySelector('.sidebar--menu .menu-link.active')) {
			document.querySelector('.sidebar--menu .menu-link.active').classList.remove('active');
		}
		if(document.querySelector('.submenu.is-active')) {
			document.querySelector('.submenu.is-active').style.height = '0px';
			document.querySelector('.submenu.is-active').classList.remove('is-active');
		}
	}

	// Menu Submenu

	var links = document.querySelectorAll('.sidebar--menu .menu-item a');
	var subLinks = ['Shop', 'Guide', 'Engagement', 'Wedding', 'Bespoke']
	for (i = 0; i < links.length; i++) {
		links[i].addEventListener("click", function(e) { 
			if(subLinks.includes(e.target.innerHTML)) {
				e.preventDefault();
				var title = e.target.innerHTML;
				var current =document.querySelector('.sidebar--menu .menu-item a.active');
				if(current) {
					current.classList.remove('active');
				}
				e.target.classList.add('active');
				openSubmenu(title);
			}
		}); 
	}

	function openSubmenu(title) {
		var title = title.split(" ")[0];
		var previous = document.querySelector('.sidebar--secondary-menu .submenu.is-active');
		if(previous) {
			previous.classList.remove('is-active');
			previous.style.height = '0px';
		}
		var current = document.querySelector('.sidebar--secondary-menu .submenu[data-id="'+title+'"]');
		if(current) {
			current.classList.add('is-active');
			current.style.height = current.querySelector('.inner-container').offsetHeight+'px';
		}
		masthead.classList.add('with-submenu');
		sidebar.classList.add('with-submenu');
	} 

	// Collection Menu Items

	var collectionLinks = document.querySelectorAll('.collection--menu-item');
	var productSidebar = document.querySelector('.menu-product--sidebar');
	var closeSidebar = document.querySelectorAll('.close-product--sidebar');
	

	for (i = 0; i < collectionLinks.length; i++) {
		collectionLinks[i].addEventListener("mouseover", function(e) {
			collectionMouseOver(e.target);
		}); 
	}

	for (i = 0; i < closeSidebar.length; i++) {
		closeSidebar[i].addEventListener("mouseover", function(e) {
			closeProductSidebar();
		}); 
	}

	function collectionMouseOver(target) {
		var current = document.querySelector('.collection--menu-item.active');
		var currentCollection = document.querySelector('.product-menu--container.is-active');
		var collectionTitle = target.innerHTML;	
		var collection = document.querySelector('.product-menu--container[data-title="'+collectionTitle+'"]');

		if(current) {
			current.style.height='';
			current.classList.remove('active');
		}

		if(currentCollection) {
			currentCollection.classList.remove('is-active');
		}

		if(collection) {
			var height = collection.querySelector('.product-menu--inner').offsetHeight; 
			collection.style.height=height+'px';
			collection.classList.add('is-active');
		}

		target.classList.add('active');
		productSidebar.classList.add('is-active');

	} 

	function closeProductSidebar() {
		productSidebar.classList.remove('is-active');
		var current = document.querySelector('.collection--menu-item.active');
		if(current) {
			current.classList.remove('active');
		}
	}
}

// Event Listeners

function eventListeners() {
	var tabs = document.querySelectorAll('.product-information--tabs .information--title');
	for (i = 0; i < tabs.length; i++) {
  		tabs[i].addEventListener("click", function(e) { 
  			if(!e.target.classList.contains('active')) {
  				document.querySelector('.information--title.active').classList.remove('active');
  				e.target.classList.add('active');
  				var tab = e.target.getAttribute('data-title');
  				document.querySelector('.product-information--tabs .information.active').classList.remove('active');
  				document.querySelector('.product-information--tabs .information[data-info="'+tab+'"]').classList.add('active');
  			}
  		});  
	}
	var articleImages = document.querySelectorAll('.carousel-images .lazy');
	for (var i = 0; i < articleImages.length; i++) {
		lazyLoadInstance.load(articleImages[i]);
	}
}

// Sitewide Carousels & Carousel Navigation

var pagination;
var productCarousel;

function initialiseCarousels() {
	const articleCarousel = new Swiper('.article--carousel', {
	  	loop: true,
	  	spaceBetween: 20,
	  	speed:1000,
	  	slidesPerView:'auto',
	  	pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: '.article-carousel-next',
			prevEl: '.article-carousel-prev', 
		}
	});

	pagination = new Swiper(".product--pagination", {
        direction: "vertical",
        slidesPerView:'auto',
        slideToClickedSlide: true,
    	spaceBetween: 30,   	 
    });
	
	productCarousel = new Swiper(".product--carousel", {
        direction: "horizontal",
        speed:1000,
        init: false,
        pagination: {
			el: ".product-carousel__pagination",
		    type: "fraction"
		},
        breakpoints: {
	    768: {
	      	direction: "vertical",
	      	pagination: '',
	    }
	  }
    });

	productCarousel.on('init', function() { carouselNav(); });
	productCarousel.on('slideChange', function (swiper) {
	  	var next = swiper.activeIndex+1;
	  	var thumb = document.querySelector('.product-pagination .swiper-slide:nth-child('+next+')');
    	document.querySelector('.product-pagination .swiper-slide.is-active').classList.remove('is-active');
    	thumb.classList.add('is-active');
	});
	productCarousel.init();
}

function carouselNav() {
	pagination.on('click', function(swiper) {
    	var slide = this.clickedIndex;
    	productCarousel.slideTo(slide, 1000);
    });
}